import { uuid } from './idHelper';

export const replaceBaseUrl = (
  originalUrl: string,
  newBaseUrl: string
): string => {
  if (!originalUrl) return originalUrl;
  const regex = /^(https?:\/\/[^/]+)(.*)$/;
  const match = originalUrl.match(regex);
  if (!match) return originalUrl;
  return `${newBaseUrl}${match[2]}`;
};

export const appendRandomQueryParam = (url: string): string => {
  if (!url) return url;
  return `${url}${url.includes('?') ? '&' : '?'}${getRandomQueryParam()}`;
};

export const getRandomQueryParam = (): string => `${uuid(true)}=${uuid(true)}`;

export const getPhotoNameFromUrl = (url: string): string => {
  if (!url) return url;
  const fullPath = url.split('/').pop();
  return fullPath.split('?')[0];
};

export const URL_REGEX = new RegExp(
  // eslint-disable-next-line no-useless-escape
  /^(http(s):\/\/.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)$/
);

export const buildDistUrl = (url: string) => {
  if (!url) return url;
  if (url.includes('s3.')) {
    return replaceBaseUrl(url, process.env.NEXT_PUBLIC_CF_PHOTOS_BASE_URL);
  }
  return url;
};

export const extractSubdomainfromUrl = (url: string): string => {
  try {
    const { hostname } = new URL(url);
    if (!hostname) return '';
    const parts = hostname.split('.');
    if (parts.length > 2) {
      const subdomain = parts[0];
      return subdomain.charAt(0).toUpperCase() + subdomain.slice(1);
    }
    return '';
  } catch {
    return '';
  }
};

export function stripTrailingSlashes(inputStr: string): string {
  if (!inputStr) {
    return '';
  }
  return inputStr.replace(/[\\/]+$/, '');
}

export const downloadUrl = (url: string, fileName: string) => {
  const shouldRun = typeof window !== 'undefined' && !!(url && fileName);

  if (!shouldRun) return;
  const a = document.createElement('a');
  a.download = fileName;
  a.href = url;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 100);
};
